import {
  Label,
  ExclamationOutlineIcon,
  IconButton,
  EditIcon,
  AddIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import classNames from "classnames"
import {
  useCallback,
  useMemo,
} from "react"

import styles from "./AccountDetails.module.scss"
import { usePhoneNumberModalContext } from "src/components"
import { usePolyglot } from "src/contexts"
import { usePhones } from "src/hooks"
import { formatPhoneNumber } from "src/utils"

const polyglotPrefix = "pages.account.account_details.phone_number."

export function PhoneNumber() {
  const polyglot = usePolyglot()
  const { openPhoneNumberModal } = usePhoneNumberModalContext()

  const phones = usePhones()

  const primaryPhone = useMemo(
    () => phones.data?.find(
      (phone) => phone.is_primary,
    ),
    [phones],
  )

  const onClick = useCallback(
    () => {
      openPhoneNumberModal(primaryPhone)
    },
    [
      primaryPhone,
      openPhoneNumberModal,
    ],
  )

  const phoneNumber = useMemo(
    () => primaryPhone ? formatPhoneNumber(primaryPhone.phone_number) : "",
    [primaryPhone],
  )

  return (
    <div id="user-phone-number">
      <Label className={styles.inputLabel}>
        {polyglot.t(`${polyglotPrefix}label`)}
      </Label>
      <div className={styles.changePhoneNumberRow}>
        {phoneNumber ? (
          <>
            <div className={styles.viewableDetails}>
              {phoneNumber}
            </div>
            <IconButton onClick={onClick}>
              <EditIcon />
            </IconButton>
          </>
        ) : (
          <>
            <div className={classNames(styles.noPhone)}>
              <ExclamationOutlineIcon
                className={styles.noPhoneIcon}
                height={20}
                width={20}
              />
              <div className={styles.noPhoneText}>
                {polyglot.t(`${polyglotPrefix}no_phone_message`)}
              </div>
            </div>
            <IconButton onClick={onClick}>
              <AddIcon />
            </IconButton>
          </>
        )
        }
      </div>
    </div>
  )
}
